import SalesLayout from "../../domain/sales/layout/SalesLayout";

export default function SalesPage() {
  return <SalesLayout />;
}
